<template>
<div class="eChart">
    <div class="title1">
      <span class="fl tip">成绩曲线</span>
      <div class="classSelect fr">
        <span class="selectActive" @click="selectShow">{{subjectName}}</span>
        <ul class="selectBox" v-if='subjectF'>
          <li v-for="(item, index) in subjectList" @click="changetype(item,index)">
            {{item}}
          </li>
        </ul>
      </div>
    </div>
    <div id="myChart" style="width: 800px;height: 330px;"></div>
  </div>
</template>
<script>
export default {
  props: ['echartData', 'userName'],
  data() {
    return {
      subjectF: false,
      subjectName: '整体曲线',
      subjectList: ['整体曲线', '单词跟读', '课文跟读', '听说模考', '线上作答', '报听写']
    }
  },
  watch: {
    echartData(curVal,oldVal){
      // if (curVal !== oldVal) {
      // }
      this.setOption()
    },
    userName (val) {
      this.setOption()
    }
  },
  created() {
    this.$nextTick(() => {
      // console.log(this.echartData, 'ghghg')
    })
  },
  methods: {
    setOption () {
      let curData = this.echartData
      if (!curData.length) {
        return false
      }
      let sendDate = []
      let sore = []
      let avgSore = []
       curData.map((item, i) => {
         sendDate.push(item.sendDate)
         let s =  Math.floor(item.userAvgScore)
         let avgS = Math.floor(item.classAvgScore)
         sore.push(s)
         avgSore.push(avgS)
       })
      this.drawLine(sendDate, sore, avgSore, this.userName)
    },
     drawLine(sendDate, sore, avgSore, userName) {
      let myChart = this.$echarts.init(document.getElementById('myChart'))
      myChart.setOption({
        tooltip: {
          show: true,
          textStyle: {
            fontStyle: 'oblique'
          }
        },
        grid:{
          x: 30,
          y: 70,
        },
        legend: {
          icon: 'rect',
          itemWidth: 10,
          itemHeight: 10,
          padding: 10,
          itemGap: 50,
          top: 0,
          selectedMode: false,
          textStyle: {
            fontSize: 12,
            color: '#999'
          },
          data: [
            {
              name: userName, 
            },
            {
              name: '班级平均',
            }
          ]
        },
        xAxis: {
          type: 'category',
          axisLine: {
            /* 横轴的字体颜色 */
            show: true,
            lineStyle: {
              color: "#666"
            }
          },
          axisLabel: {
            /* 横轴刻度状态 */
            interval: 0,
            rotate: 30
          },
          data: sendDate
        },
        yAxis: {
          type: 'value'
        },
        series: [{
          name: userName,
          data: sore,
          label: {
            normal: {
              show: true,
              position: 'top'
            }
          },
          type: 'line',
          itemStyle: {
            /* 设置线的颜色 */
            normal: {
              color: "#0CC584",
              lineStyle: {
                color: "#0CC584"
              }
            }
          },
        },
        {
            name: '班级平均',
            data: avgSore,
            label: {
              normal: {
                show: true,
                position: 'top'
              }
            },
            type: 'line',
            itemStyle: {
              /* 设置线的颜色 */
              normal: {
                color: "#FF6200",
                lineStyle: {
                  color: "#FF6200"
                }
              }
            },
          }
      ]
      });
    },
    changetype (data, i) {
      this.subjectName = data
      this.subjectF = false
      this.$emit('setresourceType', i)
    },
    selectShow () {
      this.subjectF = true
    }
  }
};
</script>



// WEBPACK FOOTER //
// echartLine.vue?4c70aaa0